import type { BariPostNurseSpecialistReportData } from '@common/validation/customControls/bariPost/bariPostNurseSpecialistReport/v1/bariPostNurseSpecialistReportSchemaV1';
import { CustomControlCode } from '@common/enums/serviceWorkflow/customControlCode';
import { CustomControlRegistry } from '../../customControlRegistry';
import { initialData } from './bariPostNurseSpecialistReportData';
import { BariPostNurseSpecialistReportEdit } from './BariPostNurseSpecialistReportEdit';
import { BariPostNurseSpecialistReportRead } from './BariPostNurseSpecialistReportRead';

CustomControlRegistry.instance.register<BariPostNurseSpecialistReportData>({
    EditElement: BariPostNurseSpecialistReportEdit,
    ReadElement: BariPostNurseSpecialistReportRead,
    canCopyReadSections: true,
    code: CustomControlCode.BariPostNurseSpecialistReport,
    initialData,
    version: 1,
});
